(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cb-asian-range"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const preview = document.querySelector('[data-cb-range-preview]');
  const link = event.target.closest?.('#facet-filters a[href]');
  if (!preview || !link) return;
  const url = new URL(link.href, window.location.origin);
  if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) return;
  url.searchParams.set('view', preview.value);
  link.href = url.toString();
}, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-cleaning-range"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const preview = document.querySelector('[data-cb-clean-preview]');
  const link = event.target.closest?.('#facet-filters a[href]');
  if (!preview || !link) return;
  const url = new URL(link.href, window.location.origin);
  if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) return;
  url.searchParams.set('view', preview.value);
  link.href = url.toString();
}, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-wok-accessories"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = () => {
    const nav = document.querySelector('.cb-wa-categories');
    const host = document.querySelector('[data-cbwa-grid]');
    if (!nav || !host || nav.dataset.ready) return;
    nav.dataset.ready = 'true';
    const links = Array.from(nav.querySelectorAll('[data-cbwa-category]'));
    const controls = document.querySelector('[data-cbwa-controls]');
    const status = document.querySelector('[data-cbwa-status]');
    const allButton = document.querySelector('[data-cbwa-all]');
    let selected = '';
    let queued = false;
    const update = () => {
      queued = false;
      const paginated = host.querySelector('[data-cbwa-paginated="true"]');
      const cards = Array.from(host.querySelectorAll('[data-cbwa-product]'));
      if (paginated) selected = '';
      const active = links.find(link => link.dataset.cbwaCategory === selected);
      const handles = active ? new Set(active.dataset.products.split('|')) : null;
      let shown = 0;
      cards.forEach(card => {
        const display = !handles || handles.has(card.dataset.cbwaProduct);
        card.hidden = !display;
        if (display) shown++;
      });
      links.forEach(link => {
        link.setAttribute('aria-pressed', String(link === active));
        link.setAttribute('role', paginated ? 'link' : 'button');
      });
      const empty = host.querySelector('[data-cbwa-empty]');
      if (empty) empty.hidden = !(active && cards.length > 0 && shown === 0);
      controls.hidden = Boolean(paginated);
      allButton.setAttribute('aria-pressed', String(!active));
      status.textContent = status.dataset.template.replace('__SHOWN__', shown).replace('__TOTAL__', cards.length).replace('__GROUP__', active ? active.querySelector('strong').textContent : allButton.textContent);
    };
    nav.addEventListener('click', event => {
      const link = event.target.closest('[data-cbwa-category]');
      if (!link || host.querySelector('[data-cbwa-paginated="true"]')) return;
      event.preventDefault();
      selected = selected === link.dataset.cbwaCategory ? '' : link.dataset.cbwaCategory;
      update();
      const target = document.querySelector(link.getAttribute('href'));
      target?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    });
    nav.addEventListener('keydown', event => {
      if (event.key === ' ' && event.target.matches('[data-cbwa-category][role="button"]')) {
        event.preventDefault(); event.target.click();
      }
    });
    allButton.addEventListener('click', () => { selected = ''; update(); });
    host.addEventListener('click', event => { if (event.target.closest('[data-cbwa-reset]')) { selected = ''; update(); } });
    document.querySelector('.cb-wa-primary')?.addEventListener('click', () => { selected = ''; update(); });
    new MutationObserver(() => {
      if (!queued) { queued = true; requestAnimationFrame(update); }
    }).observe(host, { childList: true, subtree: true });
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('click', event => {
    const preview = document.querySelector('[data-cb-wok-preview]');
    const link = event.target.closest?.('#facet-filters a[href]');
    if (!preview || !link) return;
    const url = new URL(link.href, location.origin);
    if (url.origin !== location.origin || url.pathname !== location.pathname) return;
    url.searchParams.set('view', preview.value); link.href = url.toString();
  }, true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-wok-range"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const preview = document.querySelector('[data-cb-wok-preview]');
  const link = event.target.closest?.('#facet-filters a[href]');
  if (!preview || !link) return;
  const url = new URL(link.href, window.location.origin);
  if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) return;
  url.searchParams.set('view', preview.value);
  link.href = url.toString();
}, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
